module.exports = __webpack_public_path__ + "375dbc71142eec273a6f93f75ebfbf70.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/doctor-bag-s.png
// module id = 2630
// module chunks = 0